import { render, staticRenderFns } from "./whatsappTemplatelist.vue?vue&type=template&id=2752effe&scoped=true"
import script from "./whatsappTemplatelist.vue?vue&type=script&lang=js"
export * from "./whatsappTemplatelist.vue?vue&type=script&lang=js"
import style0 from "./whatsappTemplatelist.vue?vue&type=style&index=0&id=2752effe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2752effe",
  null
  
)

export default component.exports